import { api } from "./axios";
import type { RecordingTask } from "../types";

export async function queueDownload(args: {
  device_id: number;
  channel: number;
  start: string;
  end: string;
  format: "mp4" | "avi";
}): Promise<RecordingTask> {
  const r = await api.post("/recordings/download", args);
  return r.data;
}

export async function getTask(id: number): Promise<RecordingTask> {
  const r = await api.get(`/recordings/task/${id}`);
  return r.data;
}

export async function listMyTasks(): Promise<RecordingTask[]> {
  const r = await api.get("/recordings");
  return r.data;
}

export async function deleteTask(id: number) {
  await api.delete(`/recordings/${id}`);
}

export async function downloadTaskFile(id: number): Promise<{ blob: Blob; filename: string }> {
  // El timeout global del axios (30s) es muy corto para archivos grandes
  // (~500MB/hora de grabacion HEVC). Lo desactivamos para esta llamada,
  // el browser corta solo si el server cierra el stream.
  const r = await api.get(`/recordings/file/${id}`, {
    responseType: "blob",
    timeout: 0,
  });
  const disposition = String(r.headers["content-disposition"] || "");
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  return {
    blob: r.data,
    filename: match?.[1] || `recording_${id}`,
  };
}
